import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { faCheck, faPlus, faTimes, faPencil, faHistory} from '@fortawesome/pro-light-svg-icons';
import { DatePickerComponent } from '../../../shared/components/date-picker/date-picker.component';
import { AuditService } from '../../../shared/services/audit.service';
import { EnquiryChecklistService } from '../../../shared/services/enquiry-checklist.service';
import { ComparerService } from '../../../shared/utility/comparer';
import { AddEnquiryComponent } from './add-enquiry/add-enquiry.component';
import { EditEnquiryComponent } from './edit-enquiry/edit-enquiry.component';
import { EnquiriesAuditFormComponent } from './enquiries-audit-form/enquiries-audit-form.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';


@Component({
  selector: 'app-enquiries-checklist',
  templateUrl: './enquiries-checklist.component.html',
  styleUrls: ['./enquiries-checklist.component.scss']
})
export class EnquiriesChecklistComponent implements OnInit {

  @Input() caseId: number;

  faCheck = faCheck;
  faPlus = faPlus;
  faHistory = faHistory;
  faTimes = faTimes;
  faPencil = faPencil;

  displayedColumns: string[] = ['enquiry', 'receivedDate', 'repliedDate', 'satisfiedDate', 'actions'];

  loaded: boolean = false;

  items: MatTableDataSource<any>[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private enquiryService: EnquiryChecklistService,
    private comp: ComparerService,
    private auditService: AuditService,
    private modalService: ModalService  ) {
  }

  ngOnInit(): void {
    this.loadEnquires();
  }

  loadEnquires() {
    this.loaded = false;
    // call service to load enquires
    this.enquiryService.getEnquiryChecklistForCase(this.caseId)
      .subscribe(data => {
        this.items = data.filter(x => x.isArchived == false);
        this.loaded = true;

      });
  }

  loadEnquiry(id: number) {
   
   
  }
  openAuditForForm() {

    const modalRef = this.modalService.openWithOptions(EnquiriesAuditFormComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.formName = "EnquiryChecklist";
  }

  addEnquiry() {

    const modalRef = this.modalService.openWithOptions(AddEnquiryComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;

      modalRef.result.then(
        (result) => {
          if(result)
          {
            this.enquiryService.addEnquiry(this.caseId, result)
            .subscribe(data => {
              this.loadEnquires();
            });
          }
        },
      () => {} // dismissed - do nothing
    );
  }
  editEnquiry(enquiryId: number, enquiry: string) {

    const modalRef = this.modalService.openWithOptions(EditEnquiryComponent, {size: 'md'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.enquiryId = enquiry;
    modalRef.componentInstance.enquiry = enquiry;

      modalRef.result.then(
        (result) => {
          if (result) {
            this.enquiryService.setEnquiry(enquiryId, result)
              .subscribe(data => {
                this.addAudit(this.caseId, enquiryId, "enquiry", enquiry, result);
                this.loadEnquires();
              });
          }   
        },
      () => {} // dismissed - do nothing
    );
  }

  archiveEnquiry(enquiryId: number) {

    const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
         
    modalRef.componentInstance.messageHeader = 'Are you sure you want to remove this enquiry?';
    modalRef.componentInstance.popupText1 = '';
    modalRef.componentInstance.popupText2 = '';

    modalRef.result.then(
      (result) => {
        if(result)
        {
          this.enquiryService.archive(enquiryId)
        .subscribe(data => {
          this.addAudit(this.caseId, enquiryId, "isArchived", false, true);

          this.loadEnquires();
        });
      }
    },
      () => {} // dismissed - do nothing
    );
  }

 showDatePicker(enquiryId: number, type: string, dateValue?: Date) {
  const modalRef = this.modalService.openWithOptions(DatePickerComponent, { size: 'sm' });
  
  modalRef.componentInstance.dateValue = dateValue;
  modalRef.componentInstance.canClear = (type != "receivedDate");

  modalRef.result.then((result: any) => {
    if (result != null && result.date != dateValue) {
      // call service to update date.
      switch (type) {
        case "receivedDate":
          this.enquiryService.setDateReceived(enquiryId, result.date)
            .subscribe(data => {
              this.loadEnquires();
            });
          break;
        case "repliedDate":
          this.enquiryService.setDateReplied(enquiryId, result.date)
            .subscribe(data => {
              this.loadEnquires();
            });
          break;
        case "satisfiedDate":
          this.enquiryService.setDateSatisfied(enquiryId, result.date)
            .subscribe(data => {
              this.loadEnquires();
            });
          break;
      }

      this.addAudit(this.caseId, enquiryId, type, dateValue, result.date);
    }
  }, () => {
    // Dismissed - do nothing
  });
}

  addAudit(caseId: number, enquiryId: number, field: string, oldValue: any, newValue: any) {
    var _old: any = {};
    _old[field] = oldValue;
    var _new: any = {};
    _new[field] = newValue;

    if (this.comp.objectsDifferent(_old, _new)) {
      this.auditService.auditForm(this.caseId, 'EnquiryChecklist', _old, _new, enquiryId).subscribe((response: any) => {
      });
    }
  }

}
